import React, { ReactElement } from 'react';
import { Box } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { DisplayGroupProps } from '@bcp-nextgen-dx-touchpoint-framework/react-core';
import { ComponentInfo, DisplayGroupRender } from '@components';

export const ColumnContainer: React.FC<DisplayGroupProps> = (props: DisplayGroupProps): ReactElement => {
	return (
		<ComponentInfo name="ColumnContainer">
			<Box
				styles={{
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				<DisplayGroupRender displayGroupsProps={props} />
			</Box>
		</ComponentInfo>
	);
};
